import Svg from 'components/utilities/svg'

const ReturnIcon = ({ ...props }) => (
  <Svg viewBox="0 -960 960 960" {...props}>
    <title>Return Icon</title>
    <path d="M360-240 120-480l240-240 56 56-144 144h488v-160h80v240H272l144 144-56 56Z" />
  </Svg>
)

ReturnIcon.displayName = 'Return'

export default ReturnIcon
